import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddCommentIcon from "@mui/icons-material/AddComment";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import ArticleIcon from "@mui/icons-material/Article";
import BadgeIcon from "@mui/icons-material/Badge";
import BlockIcon from "@mui/icons-material/Block";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import ChatIcon from "@mui/icons-material/Chat";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import GroupIcon from "@mui/icons-material/Group";
import HailIcon from "@mui/icons-material/Hail";
import HandymanIcon from "@mui/icons-material/Handyman";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleIcon from "@mui/icons-material/People";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RememberMeIcon from "@mui/icons-material/RememberMe";
import SegmentIcon from "@mui/icons-material/Segment";
import SettingsIcon from "@mui/icons-material/Settings";
import ThreePIcon from "@mui/icons-material/ThreeP";
import TimelineIcon from "@mui/icons-material/Timeline";
import TodayIcon from "@mui/icons-material/Today";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from '@mui/icons-material/Search';
import BallotIcon from '@mui/icons-material/Ballot';
import WebhookIcon from '@mui/icons-material/Webhook';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import InfoIcon from '@mui/icons-material/Info';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import { RoutesMap } from "../../types";
import { routeAdminType } from "../../types/typeComponents/NavSection";

export const icons = {
    AddCommentIcon,
    AddToQueueIcon,
    ArticleIcon,
    BadgeIcon,
    ChatIcon,
    ContentPasteIcon,
    DashboardIcon,
    EqualizerIcon,
    FormatListBulletedIcon,
    GroupIcon,
    HailIcon,
    HandymanIcon,
    PaidIcon,
    PeopleIcon,
    PeopleAltIcon,
    PermContactCalendarIcon,
    SegmentIcon,
    SettingsIcon,
    ThreePIcon,
    TimelineIcon,
    ManageAccountsIcon,
    AccountCircleIcon,
    NotificationsIcon,
    RememberMeIcon,
    CardMembershipIcon,
    TodayIcon,
    BlockIcon,
    ReceiptLongIcon,
    AccountBalanceIcon
};

const rutasAdminHildago: routeAdminType[] = [
    {
        id: 1,
        name: "Maestros",
        icon: <HandymanIcon />,
        rutas: [
            {
                name_ruta: "Usuarios",
                location: RoutesMap.USERS,
                icon: null,
            },
            // {
            //     name_ruta: "Documento de venta",
            //     location: RoutesMap.SALES_DOCUMENT,
            //     icon: null,
            // },
            {
                name_ruta: "Forma de pago",
                location: RoutesMap.WAY_TO_PAY,
                icon: null,
            },
            {
                name_ruta: "Sucursales",
                location: RoutesMap.BRANCH_OFFICES,
                icon: null,
            },
            {
                name_ruta: "Bodegas",
                location: RoutesMap.WAREHOUSE,
                icon: null,
            },
            {
                name_ruta: "Bodegas Desactivadas",
                location: RoutesMap.WAREHOUSE_DISABLED,
                icon: null,
            },
            {
                name_ruta: "Conductores",
                location: RoutesMap.DRIVER_LIST,
                icon: null,
            },
            {
                name_ruta: "Patentes",
                location: RoutesMap.PATENT_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 2,
        name: "Inventario",
        icon: <BallotIcon />,
        rutas: [
            {
                name_ruta: "Productos",
                location: RoutesMap.PRODUCTS,
                icon: null,
            },
            {
                name_ruta: "Registrar ingreso",
                location: RoutesMap.INTAKE_CART,
                icon: null,
            },
            {
                name_ruta: "Inventario físico",
                location: RoutesMap.STOCK_PRODUCT,
                icon: null,
            },
            {
                name_ruta: "Actualizar costos",
                location: RoutesMap.PRODUCT_COST_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 3,
        name: "Gestion Comercial",
        icon: <WebhookIcon />,
        rutas: [
            {
                name_ruta: "Proveedor/Cliente",
                location: RoutesMap.SUPPLIER_CUSTOMER,
                icon: null,
            },
            {
                name_ruta: "Vendedores",
                location: RoutesMap.SELLER,
                icon: null,
            },
            {
                name_ruta: "Lista de precios",
                location: RoutesMap.PRICE_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 4,
        name: "Facturación",
        icon: <SearchIcon />,
        rutas: [
            {
                name_ruta: "Crear pedido",
                location: RoutesMap.SEARCHER_COMPANY,
                icon: null
            },
            {
                name_ruta: "Mis pedidos",
                location: RoutesMap.MY_ORDERS,
                icon: null
            },
        ]
    },
    {
        id: 5,
        name: "Libros/Reportes",
        icon: <AttachMoneyIcon />,
        rutas: [
            {
                name_ruta: "Ventas",
                location: RoutesMap.SALES_LIST,
                icon: null,
            },
            {
                name_ruta: "Guias de despacho",
                location: RoutesMap.DG_LIST,
                icon: null,
            },
            {
                name_ruta: "Notas de crédito",
                location: RoutesMap.NC_LIST,
                icon: null,
            }
        ]
    },
    {
        id: 6,
        name: "Tesorería",
        icon: <AccountBalanceIcon />,
        rutas: [
            {
                name_ruta: "Cuentas por cobrar",
                location: RoutesMap.ACCOUNT_RECEIVABLE,
                icon: null,
            },
            {
                name_ruta: "Cartola",
                location: RoutesMap.CARTOLA,
                icon: null,
            },
            {
                name_ruta: "Libro de comprobantes",
                location: RoutesMap.PAYMENT_ENTERED,
                icon: null,
            }
        ]
    },
    {
        id: 7,
        name: "Importaciones",
        icon: <SaveAltIcon />,
        rutas: [
            {
                name_ruta: "Importar ERP",
                location: RoutesMap.IMPORT_ERP,
                icon: null,
            }
        ]
    },
    {
        id: 8,
        name: "Configuraciones",
        icon: <SettingsIcon />,
        rutas: [
            {
                name_ruta: "Integraciones ERP",
                location: RoutesMap.INTEGRATION_BY_USER,
                icon: null,
            },
        ]
    },
];

const rutasAdmin2Hildago: routeAdminType[] = [
    {
        id: 1,
        name: "Maestros",
        icon: <HandymanIcon />,
        rutas: [
            {
                name_ruta: "Usuarios",
                location: RoutesMap.USERS,
                icon: null,
            },
            {
                name_ruta: "Forma de pago",
                location: RoutesMap.WAY_TO_PAY,
                icon: null,
            },
            {
                name_ruta: "Sucursales",
                location: RoutesMap.BRANCH_OFFICES,
                icon: null,
            },
            {
                name_ruta: "Bodegas",
                location: RoutesMap.WAREHOUSE,
                icon: null,
            },
            {
                name_ruta: "Bodegas Desactivadas",
                location: RoutesMap.WAREHOUSE_DISABLED,
                icon: null,
            },
            {
                name_ruta: "Conductores",
                location: RoutesMap.DRIVER_LIST,
                icon: null,
            },
            {
                name_ruta: "Patentes",
                location: RoutesMap.PATENT_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 2,
        name: "Inventario",
        icon: <BallotIcon />,
        rutas: [
            {
                name_ruta: "Productos",
                location: RoutesMap.PRODUCTS,
                icon: null,
            },
            {
                name_ruta: "Registrar ingreso",
                location: RoutesMap.INTAKE_CART,
                icon: null,
            },
            {
                name_ruta: "Inventario físico",
                location: RoutesMap.STOCK_PRODUCT,
                icon: null,
            },
            {
                name_ruta: "Actualizar costos",
                location: RoutesMap.PRODUCT_COST_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 3,
        name: "Gestion Comercial",
        icon: <WebhookIcon />,
        rutas: [
            {
                name_ruta: "Proveedor/Cliente",
                location: RoutesMap.SUPPLIER_CUSTOMER,
                icon: null,
            },
            {
                name_ruta: "Vendedores",
                location: RoutesMap.SELLER,
                icon: null,
            },
            {
                name_ruta: "Lista de precios",
                location: RoutesMap.PRICE_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 4,
        name: "Facturación",
        icon: <SearchIcon />,
        rutas: [
            {
                name_ruta: "Crear pedido",
                location: RoutesMap.SEARCHER_COMPANY,
                icon: null
            },
            {
                name_ruta: "Mis pedidos",
                location: RoutesMap.MY_ORDERS,
                icon: null
            },
        ]
    },
    {
        id: 5,
        name: "Libros/Reportes",
        icon: <AttachMoneyIcon />,
        rutas: [
            {
                name_ruta: "Ventas",
                location: RoutesMap.SALES_LIST,
                icon: null,
            },
            {
                name_ruta: "Guias de despacho",
                location: RoutesMap.DG_LIST,
                icon: null,
            },
            {
                name_ruta: "Notas de crédito",
                location: RoutesMap.NC_LIST,
                icon: null,
            }
        ]
    },
    {
        id: 6,
        name: "Importaciones",
        icon: <SaveAltIcon />,
        rutas: [
            {
                name_ruta: "Importar ERP",
                location: RoutesMap.IMPORT_ERP,
                icon: null,
            }
        ]
    },
    {
        id: 7,
        name: "Configuraciones",
        icon: <SettingsIcon />,
        rutas: [
            {
                name_ruta: "Integraciones ERP",
                location: RoutesMap.INTEGRATION_BY_USER,
                icon: null,
            },
        ]
    },
];

const rutasAdminBasic: routeAdminType[] = [
    {
        id: 1,
        name: "Maestros",
        icon: <HandymanIcon />,
        rutas: [
            {
                name_ruta: "Usuarios",
                location: RoutesMap.USERS,
                icon: null,
            },
            {
                name_ruta: "Documento de venta",
                location: RoutesMap.SALES_DOCUMENT,
                icon: null,
            },
            {
                name_ruta: "Forma de pago",
                location: RoutesMap.WAY_TO_PAY,
                icon: null,
            },
            {
                name_ruta: "Productos",
                location: RoutesMap.PRODUCTS,
                icon: null,
            },
            {
                name_ruta: "Conductores",
                location: RoutesMap.DRIVER_LIST,
                icon: null,
            },
            {
                name_ruta: "Patentes",
                location: RoutesMap.PATENT_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 2,
        name: "Facturación",
        icon: <SearchIcon />,
        rutas: [
            {
                name_ruta: "Modelo v3",
                location: RoutesMap.SEARCHER_V3,
                icon: null
            }
        ]
    },
    {
        id: 3,
        name: "Libros/Reportes",
        icon: <AttachMoneyIcon />,
        rutas: [
            {
                name_ruta: "Ventas",
                location: RoutesMap.SALES_LIST,
                icon: null,
            }
        ]
    },
    {
        id: 4,
        name: "Importaciones",
        icon: <SaveAltIcon />,
        rutas: [
            {
                name_ruta: "Importar ERP",
                location: RoutesMap.IMPORT_ERP,
                icon: null,
            }
        ]
    },
    {
        id: 5,
        name: "Configuraciones",
        icon: <SettingsIcon />,
        rutas: [
            {
                name_ruta: "Permisos por tipo de usuario",
                location: RoutesMap.PERMISSIONS_BY_USER,
                icon: null,
            },
        ]
    },
    {
        id: 6,
        name: "Información",
        icon: <InfoIcon />,
        rutas: [
            {
                name_ruta: "Información de la aplicación",
                location: RoutesMap.INFORMATION,
                icon: null,
            },
        ]
    },
]

const rutasAdmin: routeAdminType[] = [
    {
        id: 1,
        name: "Maestros",
        icon: <HandymanIcon />,
        rutas: [
            {
                name_ruta: "Usuarios",
                location: RoutesMap.USERS,
                icon: null,
            },
            {
                name_ruta: "Documento de venta",
                location: RoutesMap.SALES_DOCUMENT,
                icon: null,
            },
            {
                name_ruta: "Forma de pago",
                location: RoutesMap.WAY_TO_PAY,
                icon: null,
            },
            {
                name_ruta: "Sucursales",
                location: RoutesMap.BRANCH_OFFICES,
                icon: null,
            },
            {
                name_ruta: "Areas de negocio",
                location: RoutesMap.BUSSINES_AREA,
                icon: null,
            },
            {
                name_ruta: "Bodegas",
                location: RoutesMap.WAREHOUSE,
                icon: null,
            },
            {
                name_ruta: "Conductores",
                location: RoutesMap.DRIVER_LIST,
                icon: null,
            },
            {
                name_ruta: "Patentes",
                location: RoutesMap.PATENT_LIST,
                icon: null,
            },
        ],
    },
    {
        id: 2,
        name: "Inventario",
        icon: <BallotIcon />,
        rutas: [
            {
                name_ruta: "Familia",
                location: RoutesMap.CATEGORIES,
                icon: null,
            },
            {
                name_ruta: "Subfamilias",
                location: RoutesMap.SUB_CATEGORIES,
                icon: null,
            },
            {
                name_ruta: "Lineas",
                location: RoutesMap.SPECIFIC_SUB_CATEGORIES,
                icon: null,
            },
            {
                name_ruta: "Tipos de atributo",
                location: RoutesMap.TYPE_ATTRIBUTES,
                icon: null,
            },
            {
                name_ruta: "Atributos de producto",
                location: RoutesMap.PRODUCT_ATTRIBUTES,
                icon: null,
            },
            {
                name_ruta: "Atributos especificos",
                location: RoutesMap.SPECIFIC_PRODUCT_ATTRIBUTES,
                icon: null,
            },
            {
                name_ruta: "Detalle atributos",
                location: RoutesMap.DETAIL_ATTRIBUTES,
                icon: null,
            },
            {
                name_ruta: "Usos de producto",
                location: RoutesMap.PRODUCT_USAGE_ATTRIBUTES,
                icon: null,
            },
            {
                name_ruta: "Usos especificos",
                location: RoutesMap.SPECIFIC_PRODUCT_USES,
                icon: null,
            },
            {
                name_ruta: "Clasificación de productos",
                location: RoutesMap.CLASSIFICATION_PRODUCTS,
                icon: null,
            },
            {
                name_ruta: "Tipos de productos",
                location: RoutesMap.TYPE_PRODUCTS,
                icon: null,
            },
            {
                name_ruta: "Productos",
                location: RoutesMap.PRODUCTS,
                icon: null,
            },
        ],
    },
    {
        id: 3,
        name: "Gestion Comercial",
        icon: <WebhookIcon />,
        rutas: [
            {
                name_ruta: "Proveedor/Cliente",
                location: RoutesMap.SUPPLIER_CUSTOMER,
                icon: null,
            },
            {
                name_ruta: "Segmentos",
                location: RoutesMap.SEGMENTS,
                icon: null,
            },
            {
                name_ruta: "Vendedores",
                location: RoutesMap.SELLER,
                icon: null,
            },
            {
                name_ruta: "Canales de venta",
                location: RoutesMap.SALE_CHANNEL,
                icon: null,
            },
            {
                name_ruta: "Lista de precios",
                location: RoutesMap.PRICE_LIST,
                icon: null,
            },
            {
                name_ruta: "Lista de productos",
                location: RoutesMap.LIST_OF_PRODUCTS,
                icon: null,
            },
        ],
    },
    {
        id: 4,
        name: "Facturación",
        icon: <SearchIcon />,
        rutas: [
            {
                name_ruta: "Por categorías",
                location: RoutesMap.SEARCHER_KFC,
                icon: null,
            },
            {
                name_ruta: "General",
                location: RoutesMap.SEARCHER_V2,
                icon: null,
            },
            {
                name_ruta: "Modelo v3",
                location: RoutesMap.SEARCHER_V3,
                icon: null
            },
            {
                name_ruta: "Crear pedido",
                location: RoutesMap.SEARCHER_COMPANY,
                icon: null
            },
            {
                name_ruta: "Mis pedidos",
                location: RoutesMap.MY_ORDERS,
                icon: null
            },
        ]
    },
    {
        id: 5,
        name: "Libros/Reportes",
        icon: <AttachMoneyIcon />,
        rutas: [
            {
                name_ruta: "Ventas",
                location: RoutesMap.SALES_LIST,
                icon: null,
            }
        ]
    },
    {
        id: 6,
        name: "Importaciones",
        icon: <SaveAltIcon />,
        rutas: [
            {
                name_ruta: "Importar ERP",
                location: RoutesMap.IMPORT_ERP,
                icon: null,
            }
        ]
    },
    {
        id: 7,
        name: "Configuraciones",
        icon: <SettingsIcon />,
        rutas: [
            {
                name_ruta: "Permisos por tipo de usuario",
                location: RoutesMap.PERMISSIONS_BY_USER,
                icon: null,
            },
            {
                name_ruta: "Integraciones ERP",
                location: RoutesMap.INTEGRATION_BY_USER,
                icon: null,
            },
        ]
    },
    {
        id: 8,
        name: "Información",
        icon: <InfoIcon />,
        rutas: [
            {
                name_ruta: "Información de la aplicación",
                location: RoutesMap.INFORMATION,
                icon: null,
            },
        ]
    },
];

const rutasSuperAdmin: routeAdminType[] = [
    {
        id: 1,
        name: "Maestros",
        icon: <PersonIcon />,
        rutas: [
            {
                name_ruta: "Compañias",
                location: RoutesMap.COMPANIES,
                icon: null,
            },
            {
                name_ruta: "Administradores",
                location: RoutesMap.ADMIN_LIST,
                icon: null,
            },
            {
                name_ruta: "Usuarios",
                location: RoutesMap.USERS,
                icon: null,
            },
            {
                name_ruta: "Planes",
                location: RoutesMap.PLANS_LIST,
                icon: null,
            },
            {
                name_ruta: "Pasos iniciales",
                location: RoutesMap.INITIAL_STEP_LIST,
                icon: null,
            },
            {
                name_ruta: "Plantillas de importación",
                location: RoutesMap.IMPORT_LIST,
                icon: null,
            },
        ],
    }
];

const rutasSalesman: routeAdminType[] = [
    {
        id: 1,
        name: "Gestion Comercial",
        icon: <WebhookIcon />,
        rutas: [
            {
                name_ruta: "Proveedor/Cliente",
                location: RoutesMap.SUPPLIER_CUSTOMER,
                icon: null,
            },
            {
                name_ruta: "Lista de precios",
                location: RoutesMap.PRICE_LIST,
                icon: null,
            },
            {
                name_ruta: "Productos",
                location: RoutesMap.PRODUCTS,
                icon: null,
            },
        ],
    },
    {
        id: 2,
        name: "Facturación",
        icon: <SearchIcon />,
        rutas: [
            {
                name_ruta: "Crear pedido",
                location: RoutesMap.SEARCHER_COMPANY,
                icon: null
            },
            {
                name_ruta: "Mis pedidos",
                location: RoutesMap.MY_ORDERS,
                icon: null
            },
        ]
    },
];

const rutasClient: routeAdminType[] = [
    {
        id: 4,
        name: "Facturación",
        icon: <SearchIcon />,
        rutas: [
            {
                name_ruta: "Crear pedido",
                location: RoutesMap.SEARCHER_COMPANY,
                icon: null
            },
            {
                name_ruta: "Mis pedidos",
                location: RoutesMap.CLIENT_ORDER_LIST,
                icon: null
            },
        ]
    },
];

export const navSections = {
    Superadmin: rutasSuperAdmin,
    Admin: rutasAdmin,
    Salesman: rutasSalesman,
    AdminBasic: rutasAdminBasic,
    AdminHildago: rutasAdminHildago,
    Client: rutasClient,
    rutasAdmin2Hildago
};
